import React, {Fragment, useState} from 'react'
import {currentLang} from './../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import { Helmet } from 'react-helmet-async';

function SchemaProduct({data}) {
    const lang = currentLang();
    const origin = window.location.origin;

    // user slider images if exists instead of single image url
    let images = data.main_slider ? data.main_slider.map((item) => {
        return item.image_url;
    }) : [data.image_url];

    let canonicalurl = origin + window.location.pathname.replace(/\/$/, "");

    let product = {
        "@type": "Product",
        "name": data.title,
        "image": images,
        "brand": {
            "@type": "Brand",
            "name": siteInfo[lang]['title']
        },
        "description": data.body ? (data.body?.replace(/<[^>]+>/g, '') || "") : "",
        "sku": data.slug,
        "offers": {
            "@type": "Offer",
            "url": canonicalurl,
            "priceCurrency": siteInfo[lang]['currency'],
            "price": data.shop_package_price,
            "availability": data.shop_product_stock_status == 'instock' ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        }
    };

    // Per-product rating — only emitted when the API supplies real per-product
    // values. The sitewide "10.000+ tevreden klanten" label is NOT product-specific
    // and must not be used here: Google requires review/rating markup to be tied to
    // the individual product, otherwise it can trigger a structured-data manual action.
    if (data.rating_value && data.rating_count && Number(data.rating_count) > 0) {
        product.aggregateRating = {
            "@type": "AggregateRating",
            "ratingValue": String(data.rating_value),
            "reviewCount": String(data.rating_count),
            "bestRating": "5",
            "worstRating": "1"
        };
    }

    // Breadcrumbs: Home > Category > Product (category derived from the URL path,
    // e.g. /nl/rundvlees/koe-pakket -> Home > Rundvlees > Koe Pakket)
    const segments = window.location.pathname.split('/').filter(Boolean); // [lang, category?, slug]
    const titleCase = (s) => s.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    const crumbs = [{
        "@type": "ListItem",
        "position": 1,
        "name": siteInfo[lang]['title'],
        "item": origin + '/' + lang
    }];
    if (segments.length >= 3) {
        crumbs.push({
            "@type": "ListItem",
            "position": 2,
            "name": titleCase(segments[segments.length - 2]),
            "item": origin + '/' + segments.slice(0, -1).join('/')
        });
    }
    crumbs.push({
        "@type": "ListItem",
        "position": crumbs.length + 1,
        "name": data.title,
        "item": canonicalurl
    });
    let breadcrumb = {
        "@type": "BreadcrumbList",
        "itemListElement": crumbs
    };

    let jsonld = {
        "@context": "https://schema.org",
        "@graph": [product, breadcrumb]
    };

    return (
        <Helmet>
        <script type="application/ld+json">
            {JSON.stringify(jsonld)}
        </script>
        </Helmet>
    )
}

export default SchemaProduct
